// RootLayout — root-route layout element.md.
// Renders the transient ordering:
// <ToastHost /> (portal singleton to document.body.md)
// <ModalHost /> (portal target #modal-host for Modal/ConfirmModal.md)
// <PopoverHost /> (portal target #popover-host for Menu primitives
//   <Outlet />             (/login, protected subtree via nested routes)
//
// Task 4.9 (4-S4) added `useAuthBootstrap()` at the top of the body: fires
// exactly once on mount (StrictMode-dedup'd via the single-flight mutex +
// AbortController in the hook itself).
import { Outlet } from 'react-router';
import { useAuthBootstrap } from '../features/auth/index.js';
import { UnsavedChangesProvider } from '../ui/index.js';
import { ToastHost } from './ToastHost.js';
import { ModalHost } from './ModalHost.js';
import { PopoverHost } from './PopoverHost.js';

export function RootLayout() {
  useAuthBootstrap();
  // INVARIANT: `UnsavedChangesProvider` must live INSIDE the data router so
  // its `useBlocker` call resolves to the active router's single blocker
  // slot. RootLayout is the root route element, so anything mounted here
  // satisfies that contract while still wrapping all protected app subtrees.
  return (
    <UnsavedChangesProvider>
      <ToastHost />
      <ModalHost />
      <PopoverHost />
      <Outlet />
    </UnsavedChangesProvider>
  );
}
